// src/context/UserContext.js
import React, { createContext, useState, useEffect } from "react";

// Create context
export const UserContext = createContext();

// Provider component
export const UserProvider = ({ children }) => {
  const [user, setUser] = useState(null);

  // Load user from localStorage
  useEffect(() => {
    const savedUser = localStorage.getItem("medarphaUser");
    if (savedUser) setUser(JSON.parse(savedUser));
  }, []);

  // ✅ FIXED Login function (loginType added)
  const loginUser = (userData, loginType) => {
    const newUser = {
      ...userData,
      loginType, // ✅ IMPORTANT FIX
    };

    setUser(newUser);
    localStorage.setItem("medarphaUser", JSON.stringify(newUser));
  };

  // ✅ FIXED updateUser (loginType preserve)
  const updateUser = (updatedData) => {
    setUser((prev) => {
      if (!prev) return updatedData;

      const newUser = {
        ...prev,
        ...updatedData,
        loginType: prev.loginType, // ✅ DON'T LOSE loginType
      };

      localStorage.setItem("medarphaUser", JSON.stringify(newUser));

      return newUser;
    });
  };

  // Logout (UNCHANGED + small cleanup)
  const logoutUser = () => {
    setUser(null);
    localStorage.removeItem("medarphaUser");
  };

  return (
    <UserContext.Provider
      value={{ user, loginUser, updateUser, logoutUser }}
    >
      {children}
    </UserContext.Provider>
  );
};